import React from 'react';
import { Button } from '@mui/material';
import styles from './style.module.scss';

//#region Types
export interface PrimaryActionButtonProps {
  /** Button label text */
  label: string;
  /** Click handler */
  onClick: () => void;
  /** Additional CSS class */
  className?: string;
}
//#endregion

/**
 * PrimaryActionButton - Pill-shaped primary CTA button
 * 
 * Design: Light blue background, rounded pill, 50px height
 * Used in sticky footer and other primary action contexts
 * 
 * @example
 * ```tsx
 * <PrimaryActionButton
 *   label="Request More Info"
 *   onClick={() => openModal()}
 * />
 * ```
 */
export default function PrimaryActionButton({
  label,
  onClick,
  className,
}: PrimaryActionButtonProps) {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      className={`${styles.component} ${className || ''}`}
      disableElevation
    >
      {label}
    </Button>
  );
}
